<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :class="[setBtnColor]"
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          :btnKey="useBtnListKey"
          @btnPorSheet="btnPorSheet" @btnBomList="btnBomList" @btnRequestList="btnRequestList" @btnViewDetail="btnViewDetail"
          @btnSubmitBidding="btnSubmitBidding" @btnPipeListSaveAsExcel="btnPipeListSaveAsExcel"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <i-label :label="'Basic Information'"/>
              </v-row>
              <v-row dense class="form-layout">
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="6">
                          <v-select
                            v-model="quotationNo"
                            :items="quotationNoList"
                            item-value="quotationNo"
                            :label="'Select No' "
                            return-object
                            single-line
                            outlined
                            dense
                            @change="quotNoChange"
                          ></v-select>
                        </v-col>
                        <v-col cols="6" class="pl-2 pt-1 quotNo">
                          {{quotStepGbn}} 
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Title</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.title" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No, POR No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.shipNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Start Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.startDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Finish Time</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.finishDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Delivery Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.delivery" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Payment Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.payment" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Purchase Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Recieve Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.recieveDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Submit Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.submitDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation Amount</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        v-model="formData.quotationAmount"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="pa-1">
                  <i-label :label="'Detail Information'"/>
                </v-col>
                <v-col cols="9" align="right" class="pa-1"  :style="receiveYn != null && receiveYn === 'Y' ? 'display: none;' : '' ">
                  <span class="pa-1 subTitle2">[Not yet Received]</span>
                </v-col>
              </v-row>
              <v-row no-gutters class="form-layout">
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="1" align="center" class="pt-1 formHeader">
                      <span>Delivery Condition</span>
                    </v-col>
                    <v-col cols="4" >
                      <v-select
                        v-model="transCond"
                        :items="transCondList"
                        item-value="sysCode"
                        :label="readonly == false ? 'selected' : '******************'"
                        return-object
                        single-line
                        outlined
                        dense
                        height="34"
                        :disabled="readonly"
                      ></v-select>
                    </v-col>
                    <v-col cols="1" align="center" class="pt-1 formHeader">
                      <span>Payment Condition</span>
                    </v-col>
                    <v-col cols="2">
                      <v-select
                        v-model="payCond"
                        :items="payCondList"
                        item-value="sysCode"
                        :label="readonly == false ? 'selected' : '******************'"
                        return-object
                        single-line
                        outlined
                        dense
                        height="34"
                        :disabled="readonly"
                      ></v-select>
                    </v-col>
                    <v-col cols="2" align="center" class="pt-1 pb-1 formHeader">
                      <span>Percent of Advance Payment</span>
                    </v-col>
                    <v-col cols="2">
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="6">
                          <v-text-field 
                            dense 
                            outlined 
                            hide-details="auto"
                            maxLength="3"
                            height="32"
                            :value="readonly == false ? '0' : '***' "
                            :disabled="readonly"
                          />
                        </v-col>
                        <v-col cols="6" class="pl-2 pt-1" >
                          %
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row no-gutters >
                    <v-col cols="1" align="center" class="pt-1 pb-1 formHeader">
                      <span>Remarks</span>
                    </v-col>
                    <v-col cols="9">
                      <v-text-field 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        height="32"
                        v-model="remark"
                      />
                    </v-col>
                    <v-col cols="2">
                      <v-row no-gutters class="row__select-no" >
                        <v-col cols="6" align="center" class="pt-1 pb-1 formHeader">
                          <span>Money Unit: </span>
                        </v-col>
                        <v-col cols="6"  >
                          <div :style="submitYn == 'Y' ? 'display: none;' : ''">
                            <v-select
                              v-model="moneyUnit"
                              :items="moneyUnitList"
                              item-value="sysCode"
                              label="Select No"
                              return-object
                              single-line
                              outlined
                              dense
                              height="32"
                            ></v-select>
                          </div>
                          <div :style="submitYn == 'Y' ? 'border: 1px solid gray; borderTop: 0px;' : 'display: none;'" class="pa-2 pb-0">
                            <span>*****</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>


              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms3020" 
                    :ref="epms3020Ref"
                    class="hipGridHeight6_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                    :onEditorPreparing="onEditorPreparing"
                    @key-down="onKeyDown"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="shipNo" caption="Ship No" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="porNo" caption="Por No" width="9%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="matlSpec" caption="Material Specition" width="34%" data-type="string" alignment="left" :allow-editing="false"/>
                    <DxColumn data-field="reqQty" caption="Quantity" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="Quotation Amount" width="8%" data-type="string" alignment="center">
                      <DxColumn data-field="quotPrc" caption="Unit Price" width="8%" data-type="string" :format="format" alignment="center" :allow-editing="true" 
                        :editor-options="{ maxLength: 12 }" :set-cell-value="quotPrcChanged" />
                    </DxColumn>
                    <DxColumn caption="Quotation Amount" width="8%" data-type="string" alignment="center" >
                      <DxColumn data-field="quotAmt" caption="Amount" width="8%" data-type="string" :format="format" alignment="center" :allow-editing="true" 
                        :editor-options="{ maxLength: 12 }" :set-cell-value="quotAmtChanged" />
                    </DxColumn>
                    <DxColumn caption="Quotation Amount" width="4%" data-type="string" alignment="center" >
                      <DxColumn data-field="quotVat" caption="VAT(%)" width="4%" data-type="string" alignment="center" :allow-editing="true" />
                    </DxColumn>
                    <DxColumn caption="Transportation Fee" width="8%" data-type="string" alignment="center" >
                      <DxColumn data-field="transAmt" caption="Amount" width="8%" data-type="string" :format="format" alignment="center" :allow-editing="true" :editor-options="{ maxLength: 10 }" />
                    </DxColumn>
                    <DxColumn caption="Transportation Fee" width="4%" data-type="string" alignment="center">
                      <DxColumn data-field="transVat" caption="VAT(%)" width="4%" data-type="string" alignment="center" :allow-editing="true" />
                    </DxColumn>
                    <!-- <DxColumn data-field="govFee" width="5%" data-type="string" :format="format" alignment="center" header-cell-template="govTemplate" 
                      :allow-editing="true" :editor-options="{ maxLength: 10 }" />
                    <template #govTemplate>
                      <div>Gov. Fee<br>(Price)</div>
                    </template> -->
                    <DxColumn data-field="canDelyDte" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" header-cell-template="deliveryTemplate" :allow-editing="true" :set-cell-value="canDelyDteSelect" />
                    <template #deliveryTemplate>
                      <div>
                        <div :style="submitYnGbn == false && gridMainList.length > 0 ? 'display: none;' : '' "><div>Can Delivery<br>Date</div></div>
                        <div :style="submitYnGbn == false && gridMainList.length > 0 ? '' : 'display: none;' "><div class="allBtn" @click="allBtn">Can Delivery<br>Date (All)</div></div>
                      </div>
                    </template>
                    <DxColumn data-field="wrtMonth" width="5%" data-type="string" alignment="center" header-cell-template="warrantyTemplate" :allow-editing="true" />
                    <template #warrantyTemplate>
                      <div>Warranty<br>(month)</div>
                    </template>
                    <DxPaging :enabled="true" :page-size="20" />
                    <!-- <DxPager :visible="false" /> -->
                  </DxDataGrid>
                </v-col>
              </v-row>

               <v-row no-gutters>
                          <v-col cols="3" class="px-1">
                            <i-label :label="'File Information : '"/>
                          </v-col>
                        </v-row>
                        <v-row v-for="row in 2" :key="'file__row_' + row" no-gutters style="height: 42px;">
                          <v-col v-for="col in 2" :key="'file__row_' + row + '__col_' + col" cols="6" :style="{ 'border-width': `${row === 1 ? '1px' : '0px'} 1px 1px ${col === 1 ? '1px' : '0px'}`, 'border-style': 'solid', 'border-color': 'gray' }">
                            <template v-if="getFileGbn(getFileIdx(row, col)) === '1'">
                              <v-row no-gutters>
                                <span class="subTitle pa-2 pr-0">{{ getFileIdx(row, col) + '. ' }}</span>
                                <v-col cols="4">
                                  <v-file-input class="pa-0" placeholder="File input" v-model="fileList[getFileIdx(row, col) - 1].fileName"></v-file-input>
                                </v-col>
                                <span class="subTitle pt-2 pl-4">Description :</span>
                                <v-col cols="full" class="pa-1">
                                  <v-text-field 
                                    dense 
                                    outlined 
                                    hide-details="auto"
                                    clearable
                                    height="32"
                                    v-model="fileList[getFileIdx(row, col) - 1].fileDesc"
                                  />
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else-if="fileGbn1 === '3'">
                              <v-row no-gutters class="align-center">
                                <span class="subTitle pa-2">{{ getFileIdx(row, col) + '. ' }}</span>
                                <a @click.stop="ftpDownload(fileList[getFileIdx(row, col) - 1].linkPath, fileList[getFileIdx(row, col) - 1].fileDesc)">
                                  {{ fileList[getFileIdx(row, col) - 1].fileDesc }}
                                </a>
                              </v-row>
                            </template>
                            <template v-else-if="fileGbn1 === '4'">
                              <v-row no-gutters>
                                <span class="subTitle pa-2 pr-0">{{ `${getFileIdx(row, col) + '. '}${fileList[getFileIdx(row, col) - 1].fileDesc ? fileList[getFileIdx(row, col) - 1].fileDesc : ''}${fileList[getFileIdx(row, col) - 1].fileName ? '(' + fileList[getFileIdx(row, col) - 1].fileName + ')' : ''}` }}</span>
                              </v-row>
                            </template>
                          </v-col>
                        </v-row> 
              
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxPager , DxKeyboardNavigation } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getQuotNoList , getRequestHead , getPipeQuotYn , getSubmitDetail , getSubmitFile , reportView} from '@/api/view/hip/common/common.js'
import { submitQuot } from '@/api/view/hip/3/epms3020.js'
import { getNumComma , getCurrentDate, toNum, getDateFormat } from '@/utils/common.js'
import { ftpDownload} from '@/api/view/hip/common/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { epms7010xls } from '@/api/view/hip/common/commonXls'

export default {
  name: 'epms3020',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPager,
    DxKeyboardNavigation
  },
  data() {
    return {
      setBtnColor: 'setBtnColor',
      unUseBtnList: [],
      useBtnList: ['btnPorSheet','btnBomList','btnSubmitBidding','btnViewDetail','btnRequestList', 'btnPipeListSaveAsExcel'],
      useBtnListTemp: ['btnPorSheet','btnBomList','btnSubmitBidding','btnViewDetail','btnRequestList', 'btnPipeListSaveAsExcel'],
      menuTitle: this.$route.meta.title,
      formData: {
        quotNo: '' , shipNo: '', title: '', startDate: '', charger: '', finishDate: '', delivery: '' , 
        payment: '', recieveDate: '', submitDate: '', quotationAmount: 0 

      },
      quotationNoList: [],
      quotationNoList2: [],
      quotationNo: '',
      quotStepGbn: '',
      format: '#,##0.############',
      transCondList: [],
      transCond: '',
      payCondList: [],
      payCond: '',
      moneyUnitList: [],
      moneyUnit: '',

      //submitYn == 'Y' ? true : false
      readonly: false,


      epms3020Ref: 'epms3020Ref',
      gridMainList: [],
      
      quotStep: 'C1',
      quotNo: '',
      receiveYn: 'N',
      submitYn: 'N',
      submitYnGbn: false,
      printYn: 'N',
      printYnGbn: false,
      filePath: '',
      strPipeYn: 'N',

      //Change key value when button is changed
      useBtnListKey: 0,

      quotPrc: [],
      quotAmt: [],
      reqQty: [],

      editGbn: '0', // 0, 1, 2
      fileList: [
        { fileName: null, filePath: null, fileDesc: null, fileSeq: null },
        { fileName: null, filePath: null, fileDesc: null, fileSeq: null },
        { fileName: null, filePath: null, fileDesc: null, fileSeq: null },
        { fileName: null, filePath: null, fileDesc: null, fileSeq: null }
      ],
      fileGbn1: '0',
      fileGbn2: '0',
      fileGbn3: '0',
      fileGbn4: '0',
      canDelyDteAll: '',
      newData: '',
      remark: '',

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms3020Ref)
    },
  },
  mounted() {
    this.editGbn = '0'
    this.fileList = [
      { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
      { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
      { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
      { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
    ]
    this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '0'
    if(this.$route.params.quotNo){
      this.quotNo = this.$route.params.quotNo
      this.quotationNo = this.$route.params.quotNo
      this.quotStep = this.$route.params.quotStep
      this.doSearchQuotNo().then(() => {
        this.doSearchMain().then(() => {
          this.searchSubmitFile()
        })
      })
    }    
    this.doSearchQuotNo()
    this.searchTransCondList()
    this.searchPayCondList()
    this.getMoneyUnitList()

  },
  methods: {
    ftpDownload(filePath, fileName) {
      this.openLoading()
      ftpDownload(filePath, fileName).finally(() => {
        this.endLoading()
      })
    },
    getFileGbn(gbn) {
      return this['fileGbn' + gbn]
    },
    getFileIdx(row, col) {
      return row * col + (col < row ? row - 1 : 0)
    },
    onKeyDown(e){
      if((e.event.keyCode > 64 && e.event.keyCode < 91) || (e.event.keyCode > 105 && e.event.keyCode < 112)){
        e.event.preventDefault();
      }
    },
    // quotPrcChanged(newData , value , currentRowData){
    //   newData.quotPrc = value
    //   this.quotPrc[currentRowData.id] = Number(value)
    //   newData.quotAmt = Math.ceil(Number(value) * Number(currentRowData.reqQty) * 100) / 100
    //   this.quotAmt[currentRowData.id] = Math.ceil(Number(value) * Number(currentRowData.reqQty) * 100) / 100
    //   this.fncCalcTotal()
    // },
    // quotAmtChanged(newData , value , currentRowData){
    //   newData.quotAmt = value
    //   this.quotAmt[currentRowData.id] = Number(value)
    //   if(this.quotAmt[currentRowData.id] != 0 && Number(currentRowData.reqQty)  != 0){
    //     newData.quotPrc = Math.ceil(Number(value) / Number(currentRowData.reqQty) * 100) / 100
    //     this.quotPrc[currentRowData.id] = Math.ceil(Number(value) / Number(currentRowData.reqQty) * 100) / 100
    //   }
    //   this.fncCalcTotal()
    // },
    // fncCalcTotal(){
    //   let totalAmt = 0
    //   for(let i = 0; i < this.reqQty.length; i++){
    //     if(this.quotPrc[i] != 0 || this.quotPrc[i] != '' ){
    //       totalAmt +=  this.reqQty[i] * this.quotPrc[i]
    //     }
    //   }
    //   this.formData.quotationAmount = getNumComma(totalAmt)
    // },
    quotPrcChanged(newData, value, currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.quotPrc = val
      newData.quotAmt = Math.ceil(val * Number(currentRowData.reqQty) * 100) / 100

      this.fncCalcTotal(newData.quotAmt, currentRowData.id)
    },
    quotAmtChanged(newData, value, currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.quotAmt = val
      if (val != 0 && Number(currentRowData.reqQty) !== 0) {
        newData.quotPrc = Math.ceil(val / Number(currentRowData.reqQty) * 100) / 100
      } else {
        newData.quotPrc = 0
      }

      this.fncCalcTotal(newData.quotAmt, currentRowData.id)
    },
    async fncCalcTotal(currVal, id) {
      await this.gridMainInstance.saveEditData()
      let total = 0

      for (let i = 0; i < this.gridMainList.length; i++) {
        if (this.gridMainList[i].id !== id) {
          total += Number(this.gridMainList[i].quotAmt)
        }
      }
      total += currVal

      this.formData.quotationAmount = getNumComma(total)    
    },
    // ---------------------- getTransCondList -------------------------
    async searchTransCondList(){
      this.openLoading('searching')
      let params = {
        code: '',
        codegr: '',
        prtCode: 'TRANS_COND',
        userFlag: 'Y'
      }
      await getCmChildCode(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            this.transCondList.push(e.codeName)
          });
          this.transCond = res.list[0].codeName
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    // ---------------------- getPayCondList -------------------------
    async searchPayCondList(){
      this.openLoading('searching')
      let params = {
        code: '',
        codegr: '',
        prtCode: 'PAY_COND',
        userFlag: 'Y'
      }
      await getCmChildCode(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            this.payCondList.push(e.codeName)
          });
          this.payCond = res.list[0].codeName
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    //moneyUnitList
    async getMoneyUnitList(){
      this.openLoading('searching')
      let params = {
        code: '',
        codegr: '',
        prtCode: 'MNY_UNIT',
        userFlag: 'Y'
      }
      await getCmChildCode(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            this.moneyUnitList.push(e.codeName)
          });
          this.moneyUnit = res.list[0].codeName
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    // ---------------------- getQuotNoList -------------------------
    async doSearchQuotNo(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'C',
        userId: this.$store.state.user.userId,
        quotDiv: 'N',
      }
      await getQuotNoList(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            this.quotationNoList.push(e.quotNo)
            if(e.quotNo == this.$route.params.quotNo){
              this.quotNo = e.quotNo
            }
          });
          this.quotationNoList2 = res.list
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    // ---------------------- doSearchMain -------------------------
    async doSearchMain(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
          quotStep: this.quotStep,
          quotDiv: '',
          quotNo: this.quotNo
        }
        console.log(this.quotStep)
        await getRequestHead(params).then(res => {
          if(res.list.length){
            // console.log(" getRequestHead : " , res) 
            let list = res.list[0]
            this.formData = {
              quotationNo: list.quotNo , shipNo: list.shipPorNo, title: list.quotTitle, startDate: list.startDte, charger: list.buyerName, finishDate: list.finishDte, 
              delivery: list.transCondDesc ,payment: list.payCondDesc, recieveDate: list.receiveDte, submitDate: list.submitDte , quotationAmount: list.quotAmtTot,

              makerCd: list.makerCd, moneUnit: list.moneUnit, payCond: list.payCond, payCondDesc: list.payCondDesc, piAmount: list.piAmount,
              quotNo: list.quotNo, quotStep: list.quotStep, shipPorNo: list.shipPorNo, transCond: list.transCond, 
            }
            this.receiveYn = list.receiveYn
            this.submitYn = list.submitYn
            this.quotStep = list.quotStep
            this.printYn = list.printYn
            if(this.submitYn == null || this.submitYn =='N' || this.submitYn == '' ){
              this.readonly = false
            } else {
              this.readonly = true
            }
            if(list.printYn == null || list.printYn =='N' || list.printYn == '' ){
              this.printYnGbn = false
            } else if(list.submitYn == null || list.submitYn =='N' || list.submitYn == ''){
              this.submitYnGbn = false
            } else {
              this.printYnGbn = true
              this.submitYnGbn = true
            }

            if(this.submitYn !== 'Y'){
              this.setBtnColor = 'setBtnColor'
            } else {
              this.setBtnColor = ''
            }

            this.transCond = list.transCondDesc
            this.payCond = list.payCondDesc
            this.moneyUnit = list.moneUnit

             if (!this.submitYn || this.submitYn === 'N') {
              this.editGbn = '0'
            } else if (!this.printYn || this.printYn === 'N') {
              this.editGbn = '1'
            } else {
              this.editGbn = '2'
            }
          }
        })

        await getSubmitDetail(params).then(res => {
        let cnt = 0
        if(res.list.length){
          res.list.forEach(e => {
            e.porNo = e.porNo + '-' + e.porSeq
            e.no = cnt + 1
            e.id = cnt++
            if(this.submitYn == null || this.submitYn =='N' || this.submitYn == '' ){
              e.quotPrc = '0'
              e.quotAmt = '0'
              e.quotVat = '0'
              e.transAmt = '0'
              e.transVat = '0'
              e.govFee = '0'
              e.canDelyDte = e.canDelyDte != null && e.canDelyDte != '' ? e.canDelyDte : e.whReqDte
            } else if(this.printYn == null || this.printYn =='N' || this.printYn == '') {
              e.canDelyDte = e.canDelyDte
            } else {
              e.quotPrc = '***************'
              e.quotAmt = '***************'
              e.quotVat = '**'
              e.transAmt = '********'
              e.transVat = '**'
              e.govFee = '******'
              e.canDelyDte = '**********'
              e.wrtMonth = '**'
            }
            this.reqQty.push(Number(e.reqQty))
            this.quotPrc.push(Number(e.quotPrc))
            this.quotAmt.push(Number(e.quotAmt))
          });
          this.gridMainList = res.list
          this.canDelyDteAll = this.gridMainList[0].canDelyDte
        }
      })

      await getPipeQuotYn(params).then(res => {
        if(res.list.length){
          this.strPipeYn = res.list[0].yn
        }
      })

      this.setBtnList()
      } finally{
        this.endLoading()
      }
    },
    // --------------------------------------- getSubmitFile -----------------------------------------------
    async searchSubmitFile(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: this.quotStep,
        quotNo: this.quotNo
      }
      await getSubmitFile(params).then(res => {
        if(res.list.length){
          for(let i = 0; i < res.list.length; i++){
            this.fileList[i] = {
              fileName: res.list[i].fileName,
              filePath: res.list[i].linkPath,
              fileDesc: res.list[i].fileDesc,
              fileSeq: res.list[i].fileSeq
            }
          }
        } else {
          this.fileListSize = 0
        }
        this.fileListSize = res.list.length

        if (!this.submitYn || this.submitYn === 'N') {
          this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '1'
        } else {
          for (let i = 0; i < this.fileList.length; i++) {
            if (!this.fileList[i].fileName) {
              this[`fileGbn${i + 1}`] = '2'
              continue
            }

            if (!this.printYn || this.printYn === 'N') {
              this[`fileGbn${i + 1}`] = '3'
              continue
            }

            this[`fileGbn${i + 1}`] = '4'
          }
        }

      }).finally(() => {
        this.endLoading()
      })
    },
    // ---------------------- quotNoChange -------------------------
    quotNoChange(e){
      this.quotationNoList2.forEach(element => {        
        if (element.quotNo == e) {
          this.quotStep = element.quotStep
          if(element.quotStep === 'C2'){
            this.quotStepGbn = '1st re-Bid'
          } else if(element.quotStep === 'C3'){
            this.quotStepGbn = '2nd re-Bid'
          } else if(element.quotStep === 'C4'){
            this.quotStepGbn = '3rd re-Bid'
          } else {
            this.quotStepGbn = ''
          }
        } 
      });
      this.quotNo = this.quotationNo
      this.doSearchQuotNo().then(() => {
        this.doSearchMain().then(() => {
          this.searchSubmitFile()
        })
      })
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
      } else {
        this.merge(e)
      }
    },
    merge(e){
      if(e.column.caption === 'Quotation Amount'){
        if(e.columnIndex == '6'){
          // console.log(" >>> " , e)
          e.cellElement.setAttribute('colspan' , 3)
        }else {
          e.cellElement.style.display = 'none'
        }
      } else if(e.column.caption === 'Transportation Fee'){
        if(e.columnIndex == '9'){
          e.cellElement.setAttribute('colspan' , 2)
        }else {
          e.cellElement.style.display = 'none'
        }
      }
      e.cellElement.style['vertical-align'] = 'middle'
    },
    btnViewDetail(){
      this.$router.push({name: 'epms3010' , params:{quotNo: this.quotNo , quotStep: this.quotStep} });
    },
    btnRequestList(){
      this.$router.push({name: 'epms3000' });
    },
    btnPorSheet(){
      if(!this.quotNo || this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.quotNo,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnBomList(){
      if(!this.quotNo || this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.quotNo,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnSubmitBidding(){
      await this.gridMainInstance.saveEditData()

      // Check Already submitted
      if(this.submitYn != null && this.submitYn == 'Y'){
        return
      }
      // Check Quotation No
      if(!this.quotNo && this.quotNo == ''){
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      }
      // Check Receive
      if(this.receiveYn !== null && this.receiveYn !== 'Y'){
        this.vToastify(this.$t('Not yet Received'), 'warn')
        return
      }
      // Amount Check
      console.log('remark ', this.remark)
      if (this.formData.quotationAmount == 0) {
       
        if(this.remark == null || this.remark == ''){
          this.vToastify(this.$t('Cannot submit.'+'<br>'+'Quotation Amount is 0 and Remarks is null.'), 'warn')
          return
        }
      }else {
        for(let i = 0; i < this.gridMainList.length; i++){
          if(this.gridMainList[i].lastAmt >= 0 && Number(this.gridMainList[i].lastAmt) < Number(this.gridMainList[i].quotAmt)){
            this.vToastify(this.$t('This submit amount is greater than previous amount.'), 'warn')
            return
          }
        }
      }
      
      const formData = new FormData()

      let shipNo = this.formData.shipPorNo.split(',')
      let porNo = this.formData.shipPorNo.split(' ')
      
      this.formData.shipNo = shipNo[0]
      this.formData.porNo = porNo[1]            
      
      this.formData.moneyUnit = this.moneyUnit
      this.formData.remark = this.remark
      this.formData.userId = this.$store.state.user.userId
      this.formData.userIp = this.$store.state.user.userIp

      for(let i = 0; i < this.fileList.length; i++) {
        if(this.fileList[i].fileName) {
          formData.append('files', this.fileList[i].fileName)
          formData.append('fileDescs', this.fileList[i].fileDesc)
        }
      }

      let gridParaMainList = this.gridMainList

      for (let i = 0; i < this.gridMainList.length; i++) {
        let porNo   = this.gridMainList[i].porNo
        let quotPrc = this.gridMainList[i].quotPrc
        let quotAmt = this.gridMainList[i].quotAmt
        let canDelyDte = this.gridMainList[i].canDelyDte
        gridParaMainList[i].canDelyDte = getDateFormat(canDelyDte)
        gridParaMainList[i].porNo      = porNo.slice(0, 8)
        gridParaMainList[i].quotPrc    = quotPrc.toString().replace(/,/g, '')
        gridParaMainList[i].quotAmt    = quotAmt.toString().replace(/,/g, '')
      }

      console.log(gridParaMainList)

      formData.append('masterData', JSON.stringify(this.formData))
      formData.append('detailData', JSON.stringify(gridParaMainList))

      // VAT Check
      let cnt = 0
      if (this.$store.state.user.makerCd != '90263' && this.$store.state.user.makerCd != '95987') {        
        for (let j = 0; j < this.gridMainList.length; j++) {
          if (this.gridMainList[j].quotVat == '0') {
            cnt++
          }
        }
      }       
        if(cnt > 0){
          this.vToastifyPrompt(
            this.$t("Some item's VAT is 0."+"<br>"+"Continue?"),
            'info',
              current => {
                // File Check
                //console.log(this.fileList)
                if(this.fileList[0].fileName && (this.fileList[0].fileDesc === null || this.fileList[0].fileDesc === '')){
                  this.vToastify(this.$t("Input File1 description."), 'warn')
                  return
                }
                if(this.fileList[1].fileName && (this.fileList[1].fileDesc === null || this.fileList[1].fileDesc === '')){
                  this.vToastify(this.$t("Input File2 description."), 'warn')
                  return
                }
                if(this.fileList[2].fileName && (this.fileList[2].fileDesc === null || this.fileList[2].fileDesc === '')){
                  this.vToastify(this.$t("Input File3 description."), 'warn')
                  return
                }
                if(this.fileList[3].fileName && (this.fileList[3].fileDesc === null || this.fileList[3].fileDesc === '')){
                  this.vToastify(this.$t("Input File4 description."), 'warn')
                  return
                }

                // Can Delivery Date Check
                let curDate = getCurrentDate(1);
                for(let a = 0; a < this.gridMainList.length; a++){
                  if( this.gridMainList[a].canDelyDte < curDate){
                    this.vToastify(this.$t("Can Delivery Date is earlier than today."), 'warn')
                    return
                  }
                }

                this.vToastifyPrompt(
                  this.$t('Do you want to submit the Bidding quotation?'),
                  'info',
                    current => {
                      this.openLoading('searching')
                      submitQuot(formData)
                        .then(res => {
                          const result = res.body
                          if(result == 'OK'){
                            this.quotNoChange()
                            notify(this.$t('Bid Quotation Submit is completed.'), 'success', 3000)
                          } else {
                            this.vToastify(this.$t(result), 'warn')
                          }
                        })
                        .catch(error => {
                          this.vToastify(error, 'warn')
                          this.endLoading()
                        })
                        .finally(() => {
                          this.endLoading()
                        })
                    },
                  null,
                  true
                )
              },
            null,
            false
          )
          return
        } else {
        // File Check
        if(this.fileList[0].fileName && (this.fileList[0].fileDesc == null || this.fileList[0].fileDesc == '')){
          this.vToastify(this.$t("Input File1 description."), 'warn')
          return
        }
        if(this.fileList[1].fileName && (this.fileList[1].fileDesc == null || this.fileList[1].fileDesc == '')){
          this.vToastify(this.$t("Input File2 description."), 'warn')
          return
        }
        if(this.fileList[2].fileName && (this.fileList[2].fileDesc == null || this.fileList[2].fileDesc == '')){
          this.vToastify(this.$t("Input File3 description."), 'warn')
          return
        }
        if(this.fileList[3].fileName && (this.fileList[3].fileDesc == null || this.fileList[3].fileDesc == '')){
          this.vToastify(this.$t("Input File4 description."), 'warn')
          return
        }

        // Can Delivery Date Check
        let curDate = getCurrentDate(1);
        for(let a = 0; a < this.gridMainList.length; a++){
          if( this.gridMainList[a].canDelyDte < curDate){
            this.vToastify(this.$t("Can Delivery Date is earlier than today."), 'warn')
            return
          }
        }

        this.vToastifyPrompt(
          this.$t('Do you want to submit the Bidding quotation?'),
          'info',
            current => {
              this.openLoading('searching')
              submitQuot(formData)
                .then(res => {
                  const result = res.body
                  if(result == 'OK'){
                    this.quotNoChange()
                    notify(this.$t('Bid Quotation Submit is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(result), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.endLoading()
                })
            },
          null,
          true
        )
      }
    },
    // Pipe
    btnPipeListSaveAsExcel(){
      if(!this.quotNo && this.quotNo === ''){
        this.vToastify(this.$t('Quotation number is not selected.'), 'warn')
        return
      }

      const param = {
        quotNo: this.quotNo,
        makerCd: this.$store.state.user.makerCd,
        quotStep: this.quotStep
      }
      epms7010xls(param)

    },
    async allBtn(){
      if(this.canDelyDteAll == '' || !this.canDelyDteAll ){
        this.vToastify(this.$t('Select date at first row.'), 'warn')
        return
      }
      await this.gridMainInstance.saveEditData()
      this.gridMainInstance.beginUpdate()
      for(let i = 0; i < this.gridMainList.length; i++){
        this.gridMainList[i].canDelyDte = this.canDelyDteAll
      }
      this.gridMainInstance.endUpdate()
    },
    canDelyDteSelect(newData , value , currentRowData){
      newData.canDelyDte = value
      if(currentRowData.id == 0){
        this.canDelyDteAll = value
      }
    },
    onEditorPreparing(e){
      if(e.parentType == 'dataRow' && (e.caption == 'VAT(%)' || e.caption == 'Wrt Month')){
        e.editorOptions.maxLength = 2;
      }
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      if(this.submitYn === 'Y') {
        this.unUseBtnList.push('btnSubmitBidding')
      }

      if(this.pipeYn !== 'Y') {
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnPipeListSaveAsExcel'
        })
      }

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    fileOpen(e){
      let file = ''
      if(e === '1'){
        file = this.fileList[0].filePath
      }else if(e === '2'){
        file = this.fileList[1].filePath
      }else if(e === '3'){
        file = this.fileList[2].filePath
      }else {
        file = this.fileList[3].filePath
      }
      this.openLoading('searching')
      ftpDownload(file)
      .finally(() => {
        this.endLoading()
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: black;
  font-size: 9pt;
}
.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}

$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnSubmitBidding]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
.allBtn {
  cursor: pointer;
}
.allBtn:hover {
  color: #4980BC;
}
</style>